import React, { useEffect } from 'react'
import useResetStore from '../../state/Reset.store'
import { ChangePin } from './change-pin'
import { Reset } from './reset'
import { screens } from './types'
import { VerifyOTP } from './verify-otp'

const ResetIndex = () => {
  const [screen, reset] = useResetStore((state) => [state.screen, state.reset])

  useEffect(() => {
    reset()
  }, [reset])

  switch (screen) {
    case screens.ENTER_EMAIL: {
      return <Reset />
    }
    case screens.ENTER_OTP: {
      return <VerifyOTP />
    }
    case screens.RESET_PIN: {
      return <ChangePin />
    }
    default:
      return <Reset />
  }
}

export { ResetIndex }
